import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { MsalProvider } from '@azure/msal-react';


import App from './App';
import { store } from './app/store';
import { APP_CURRENT_VERSION } from './config';
import ProtectedRoute from './admin/utils/protectedRoute';
import { msalInstance } from './admin/utils/msalConfig';
import AdminHome from './admin';
import Signin from './admin/signin';
import Success from './features/success';
import AppErrorBoundary from './components/AppErrorBoundary';
import RouteErrorPage from './components/RouteErrorPage';
import AppToastProvider from './components/AppToastProvider';
import { installGlobalFetchErrorHandling, notifyError } from './errors/errorHandling';
import 'react-toastify/dist/ReactToastify.css';
import './admin/components/onboarding/toastStyles.css';

installGlobalFetchErrorHandling();

const currentAppVersion = APP_CURRENT_VERSION; // Update this with each deployment as needed

  const storedData = localStorage.getItem('currentAppVersion');

  if (!storedData || storedData !== currentAppVersion) {
    // Clear outdated data or migrate it
    // console.log("Local Storage Cleared!");
    localStorage.removeItem('navigatorState')
    localStorage.setItem('currentAppVersion', currentAppVersion);
    // Optionally, initialize with new structure or perform migration logic here
  }

  msalInstance.handleRedirectPromise()
    .then(response => {
        if (response) {
            // After Microsoft auth, land on /admin. AdminHome's URL-redirect
            // effect then routes the user to the correct default landing based
            // on role (HR/Accounting/Super Admin → /admin/onboarding-profiles,
            // Employee → /employee/generate-link).
            window.location.pathname = "/admin"
        }
    })
    .catch(err => {
        console.error("Error handling redirect:", err);
        notifyError(err, {
          title: 'We could not complete sign in',
          details: ['Please refresh the page and try signing in again.'],
          toastId: 'auth:redirect',
        });
    });
const root = ReactDOM.createRoot(document.getElementById('root'));

// React Router. All 4 prefixes mount AdminHome — the URL slug + the user's
// role together decide which panel renders:
//   /admin/*           → non-gamify admin pages (HR/Accounting/Super Admin)
//   /employee/*        → non-gamify employee pages (Branch Manager)
//   /gamify-admin/*    → admin gamify view (Super Admin only, Onboarding tab)
//   /gamify-employee/* → player gamify view (Employee only, Onboarding tab)
const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <RouteErrorPage />,
    element: <App />
  },
  {
    path: "/success",
    errorElement: <RouteErrorPage />,
    element: <Success />
  },
  {
    path: "/login",
    errorElement: <RouteErrorPage />,
    element: <Signin />
  },
  {
    path: "/admin/*",
    errorElement: <RouteErrorPage />,
    element: (
      <ProtectedRoute>
        <AdminHome />
      </ProtectedRoute>
    )
  },
  {
    path: "/employee/*",
    errorElement: <RouteErrorPage />,
    element: (
      <ProtectedRoute>
        <AdminHome />
      </ProtectedRoute>
    )
  },
  {
    path: "/gamify-admin/*",
    errorElement: <RouteErrorPage />,
    element: (
      <ProtectedRoute>
        <AdminHome />
      </ProtectedRoute>
    )
  },
  {
    path: "/gamify-employee/*",
    errorElement: <RouteErrorPage />,
    element: (
      <ProtectedRoute>
        <AdminHome />
      </ProtectedRoute>
    )
  }
])
root.render(
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <AppErrorBoundary>
        <AppToastProvider />
        <RouterProvider router={router} />
      </AppErrorBoundary>
    </MsalProvider>
  </Provider>
);

